import React, { FunctionComponent, memo } from 'react'

import { getFullName } from '@/helpers/utils'
import { GroupAuthorityNames, UserDetailsInfo } from '@/models/auth'

import { UserEntity, UserInfoWrapper, UserName } from '../common/private-layout-styles'

interface Props {
  user: UserDetailsInfo
  withEntity?: boolean
}

export const UserInfo: FunctionComponent<Props> = memo(({ user, withEntity }: Props) => {
  const entity = withEntity && GroupAuthorityNames[user.groups[0]]

  return (
    <UserInfoWrapper>
      <UserName>{getFullName(user.firstName, user.lastName)}</UserName>
      {withEntity && <UserEntity>{entity}</UserEntity>}
    </UserInfoWrapper>
  )
})
